import * as types from './types'

export const mutations = {
	[types.SET_INVESTMENT_PRODUCTS] (state, data) {
		state.investment_products = data
	},
	[types.SET_INVESTMENT_PRODUCT] (state, data) {
		const index = state.investment_products.findIndex((item) => item.id === data.id)

		if (index > -1) {
			state.investment_products[index] = data
		} else {
			state.investment_products.push(data)
		}
	},
	[types.ADD_INVESTMENT_PRODUCT] (state, data) {
		state.investment_products.push(data)
	},
	[types.DELETE_INVESTMENT_PRODUCT] (state, id) {
		state.investment_products = state.investment_products.filter((product) => product.id !== id)
	}
}



// WEBPACK FOOTER //
// ./src/common/store/Investment/mutations.js